import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxAccordionComponent, DxDropDownBoxComponent, DxListComponent, DxSelectBoxComponent, DxTabPanelComponent, DxValidatorComponent } from 'devextreme-angular';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { MajorSegment, PostCodesLocation, SalesRegion, StateProvinceCRM, Territory } from 'src/app/common/model/shared.model';
import { CrmDataByZipTerritoryService } from './crm-data-by-zip-territory.service';


export class CRMReportRequest {
  requestedReports: string[];
  majorSegments: string[];
  gasPlant: string;
  contractExpiresMonths?: number;
  competitorOrSupp?: string;
  searchyBy: string;
  salesSubRegionId?: string;
  salesSubRegionValue?: string;
  doAllSalesRegionAcctsOnly?: boolean;
  territoryId?: string;
  territoryValue?: string;
  radiusCountryCode?: string;
  postCodeId?: number;
  postCodeValue?: string
  radiusMiles?: number  
}

@Component({
  selector: 'app-crm-data-by-zip-territory',
  templateUrl: './crm-data-by-zip-territory.component.html',
  styleUrls: ['./crm-data-by-zip-territory.component.scss']
})
export class CRMDataByZipTerritoryComponent implements OnInit {
  
  
  @ViewChild('segmentlist', { static: false }) segmentList: DxListComponent;
  @ViewChild('segmentDropDown', { static: false }) segmentDropDown: DxDropDownBoxComponent;

  @ViewChild('segmentValidator', { static: false }) segmentValidator: DxValidatorComponent;
  @ViewChild('reportList', { static: false }) reportList: DxListComponent;
  @ViewChild('reportListValidator', { static: false }) reportListValidator: DxValidatorComponent;

  @ViewChild('territoryBox', { static: false }) territorySelectBox: DxSelectBoxComponent;
  @ViewChild('salesSubRegionBox', { static: false }) salesSubRegionBox: DxSelectBoxComponent;
  @ViewChild('countriesBox', { static: false }) countriesBox: DxSelectBoxComponent;

  @ViewChild('filtersAccordion', { static: false }) filtersAccordion: DxAccordionComponent;
  @ViewChild('tabPanel', { static: false }) tabPanel: DxTabPanelComponent;

  @ViewChild('tabOutlet', { read: ViewContainerRef }) tabOutlet: ViewContainerRef;
  @ViewChild('tabTemplate', { read: TemplateRef }) tabTemplate: TemplateRef<any>;

  reports: string[] = [];

  reports_all = ['Current Customer',
  'Leads',
  'Opportunities',
  'CRM Prospects',  
  'Suspects from D&B, all Segments'];

  reports_co2 = ['Leads',
  'Opportunities'];

  segments: MajorSegment[];

  gasPlants: Object[] = [{name: 'LOX/LIN', value: 'LOXLIN'}, {name: 'CO2', value: 'CO2'}];

  competitor_or_supplier_list: string[] = [
    'Air Liquide', 'Praxair', 'Linde'
  ];

  searchByOptions: string[] = ['Territory', 'Radius Around Zip'];

  sales_sub_regions: string[] = [];

  salesSubRegions: SalesRegion[] = [];

  territoriesMap = new Map<number, Territory[]>();
  territories: Territory[];

  radius_countries: string[] = ['USA', 'Canada'];

  radiusCountries: StateProvinceCRM[];

  segmentValue: string[];
  isAllSegmentsSelected: boolean = false;
  searchBy: string = this.searchByOptions[0];
  enableContractExpires: boolean = false;
  enableContractExpMonths: boolean = false;
  checkContractExpires: boolean = false;
  contractExpMonthsValue: number;
  majorSegmentRequired: boolean = true;

  gasPlantSelected: string = 'LOXLIN';

  enableCompetitorSupp: boolean = false;
  enableCompetitorSuppSelect: boolean = false;
  checkCompetitorSupp: boolean = false;
  competitorSuppValue: string;

  currSalesRegion: string = "US-North";
  validationErrors: any[] = [];
  requestedReportError: boolean = false;
  doAllSalesRegionAcctsOnly: boolean = false;
  
  segmentsGetDone: boolean = false
  salesRegionGetDone: boolean = false;
  territoriesGetDone: boolean = false;
  countriesGetDone: boolean = false;
  postCodeDetailsGetDone: boolean = true;

  postCodePopupVisible: boolean = false;
  postCodeValue: string = '';
  postCodeId: number = 0;
  postalCodeSearchData: PostCodesLocation[] = [];

  radiusMilesValue: number = 20;
  showTabPanel: boolean = false;

  crmReportRequest: CRMReportRequest = new CRMReportRequest();
  selectedTabIndex: number = 0;

  constructor(private crmDataByZipTerritoryService: CrmDataByZipTerritoryService, 
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef) {    
    this.reports.push(...this.reports_all);    
  }

  ngOnInit(): void {

    this.getMajorSegments();
    this.getSalesRegions();
    this.getCountries();

  }


  getMajorSegments(){

    this.crmDataByZipTerritoryService.getMajorSegmentList().subscribe({
      next: majorSegmentsData => {
        this.segments = majorSegmentsData;
        this.segmentsGetDone = true;
        
      },
      error: (error: any) => {
        this.notificationService.alert("error", "Error while fetching Major Segments data", error);
        this.segmentsGetDone = true;
      }

    });
  }


  getSalesRegions(){
    this.crmDataByZipTerritoryService.getSalesRegionList().subscribe({
      next: salesRegionData => {
        this.salesSubRegions = salesRegionData.filter(region => region.name != '?');        
        this.salesSubRegionBox.value = this.salesSubRegions.find(region => region.name == 'US-North').salesRegionId;
        this.salesRegionGetDone = true;                        
      },
      error: (error: any) => {
        this.notificationService.alert("error", "Error while fetching Sales Region data", error);
        this.salesRegionGetDone = true;
      }

    });
  }

  sortByTerritoryNameAsc = (a: Territory, b: Territory): number => {
    if(a.territoryName < b.territoryName) return -1;
    if(a.territoryName > b.territoryName) return 1;
    if(a.territoryName == b.territoryName) return 0;

    return 0;
  }

  sortTFirst_MNext 

  getTerritoriesBySalesRegion(salesRegionId: number){

    this.territoriesGetDone = false;

    if(this.territoriesMap.has(salesRegionId)){
      this.territories = this.territoriesMap.get(salesRegionId);
      this.territorySelectBox.value = this.territories[0]?.territoryId;
      this.territoriesGetDone = true;      
    }else{
      this.crmDataByZipTerritoryService.getTerritoryListBySalesRegion(salesRegionId).subscribe({
        next: territoryData => {
          let territoryDataSortedAsc = territoryData
                        .filter(item => item.territoryName != 'n/a')
                        .sort(this.sortByTerritoryNameAsc);
                                 
          //To list the territory names starting with T first, followed by anything else.
          let territoryData_TCodes_First = [...territoryDataSortedAsc.filter(t => t.territoryName.startsWith("T")),
                                            ...territoryDataSortedAsc.filter(t => !t.territoryName.startsWith("T"))]
                                            
          this.territoriesMap.set(salesRegionId, territoryData_TCodes_First);
          this.territories = territoryData_TCodes_First;
          this.territorySelectBox.value = this.territories[0]?.territoryId;
  
          this.territoriesGetDone = true;        
        },
        error: (error: any) => {
          this.notificationService.alert("error", "Error while fetching Territories data", error);
          this.territoriesGetDone = true;        
        }
      });
    }

    
  }

  getCountries(){

    this.crmDataByZipTerritoryService.getCountries().subscribe({
      next: stateProvData => {
        
        this.radiusCountries = stateProvData
        this.countriesBox.value = 'US';

        this.countriesGetDone = true;        
      },
      error: (error: any) => {
        this.notificationService.alert("error", "Error while fetching Countries data", error);
        this.countriesGetDone = true;        
      }
    });
  }


  onReportSelectionChanged(e) {    

    if(this.reportList?.selectedItems?.length > 0){
      this.requestedReportError = false;
      this.removeValidationError('requestedReport');
    }

    this.enableContractExpires = this.reportList?.selectedItems?.filter(reportType => (reportType == 'Current Customer'
      || reportType == 'Opportunities')).length > 0;

    if (!this.enableContractExpires) {
      this.checkContractExpires = false;
    }

    this.enableCompetitorSupp = this.reportList?.selectedItems?.filter(reportType => (reportType == 'Opportunities')).length > 0;

    if (!this.enableCompetitorSupp) {
      this.checkCompetitorSupp = false;
    }

    if(this.isOnlySuspectsReportSelected()){
      this.majorSegmentRequired = false;
      this.segmentValidator.instance.validate();
    }else{
      this.majorSegmentRequired = true;
    }
  }

  adapterConfig = {
    getValue: () => {
      return this.reportList?.selectedItems?.length; //-- value to be validated
    },
  };

  validationCallback(params) {    
    return params.value != 0;
  }

  onReportListValidated(e) {
    if (!e.isValid) {
      this.requestedReportError = true;
      this.validationErrors.push({ errorType: 'requestedReport', message: 'Requested Reports - Select at least one report.' });
    }
  }

  onDropDownBoxValueChanged(e) {

    this.segmentValidator.instance.validate();    
    this.updateSelection(this.segmentList && this.segmentList.instance);
  }


  updateSelection(segmentList) {
    if (!segmentList) return;    

    if (!this.segmentValue) {
      segmentList.unselectAll();
    }

  }

  onsegmentListSelectionChanged(e) {        
    this.segmentValue = this.segmentList.selectedItemKeys; 
  }

  onSegmentListSelectAllChanged(e){
    this.isAllSegmentsSelected = e.value;
  }

  adapterConfig_segmentList = {
    getValue: () => {
      if(!this.majorSegmentRequired){
        return 1;
      }else{
        return this.segmentList?.selectedItemKeys?.length; //-- value to be validated
      }      
    },
  };

  validationCallback_segmentList(params) {
    return (params.value)? params.value != 0 : false;
  }

  onSegmentSelectValidated(e) {    

    if(e.isValid || (!e.isValid && !this.majorSegmentRequired)){ 
      this.segmentDropDown.validationStatus = "valid";
      this.removeValidationError('segmentList');           
      return;
    }

    if (!e.isValid && this.majorSegmentRequired && this.validationErrors.findIndex(item => item.errorType == 'segmentList') == -1) {
      this.segmentDropDown.validationStatus = "invalid";
      this.validationErrors.push({ errorType: 'segmentList', message: 'Major Segment - Select at least one segment.' });
    }
  }

  removeValidationError(errorType: string) {
    this.validationErrors = this.validationErrors.filter(error => error.errorType != errorType);
  }

  onGasPlantValueChanged(e){    

    this.reportList.selectedItems = [];
    this.reports = [];

    this.reports.push(...this.reports_all);
  }

  onChanged_contractExpires(e) {
    this.enableContractExpMonths = e.value;

    if(this.enableContractExpMonths && !this.contractExpMonthsValue){
      this.contractExpMonthsValue = 12;
    }
  }

  onChanged_competitorSupp(e) {
    this.enableCompetitorSuppSelect = e.value;
  }

  onChanged_salesRegion(e){    

    if(e.value){
      this.currSalesRegion = this.salesSubRegions.find(item => item.salesRegionId == e.value).name;
      this.getTerritoriesBySalesRegion(e.value);
    }
  }

  onCompetitorSuppSelectValidated(e) {
    if (!e.isValid && this.validationErrors.findIndex(item => item.errorType == 'compSuppSelect') == -1) {
      this.validationErrors.push({ errorType: 'compSuppSelect', message: 'Competitor or Supplier - Select a value.' });
    }
  }

  onPostalCodeValidated(e){

    //validate only if search-by 'radius around zip' is selected, otherwise re-set any prev validations
    if(this.searchBy != 'Radius Around Zip' && !e.isValid){
      e.component.instance().reset();
      return;
    }

    if (!e.isValid){

      if(e.brokenRule.type == 'required'){
        if(this.validationErrors.findIndex(item => item.errorType == 'postalCode') == -1 ){
          this.validationErrors.push({ errorType: 'postalCode', message: 'Postal Code - Required.' });
        }
      }

      if(e.brokenRule.type == 'stringLength'){
        if(this.validationErrors.findIndex(item => item.errorType == 'postalCode') == -1 ){
          this.validationErrors.push({ errorType: 'postalCode', message: 'Postal Code - Enter at least 5 characters.' });
        }
      }      
      
    }
  }

  showCloserPostalCodes(countryId: string, postCodePartial: string){

    this.postCodeDetailsGetDone = false;

    this.crmDataByZipTerritoryService.searchPostCode(countryId, postCodePartial).subscribe({
      next: postCodeData => {
        
        if(postCodeData.length == 0){
          this.validationErrors.push({ errorType: 'postalCode', message: 'Postal Code - Invalid; Unable to find closer postal codes.' });
        }else{
          this.postalCodeSearchData = postCodeData;
          this.postCodePopupVisible = true;
        }            

        this.postCodeDetailsGetDone = true;       
      },
      error: (error: any) => {
        this.notificationService.alert("error", "Error while fetching Postal Code Data", error);
        this.postCodeDetailsGetDone = true;        
      }
    });
  }

  zipSelected(zip: string){
    
    this.postCodeValue = zip;    
    this.postCodePopupVisible = false;

  }

  submit(e) {   

    this.requestedReportError = false;
    this.validationErrors = [];

    let listValdnResult = this.reportListValidator.instance.validate();    
    let otherValdnResult = e.validationGroup.validate();

    if(listValdnResult.isValid && otherValdnResult.isValid){
      if(this.searchBy == 'Radius Around Zip'){

        this.postCodeDetailsGetDone = false;
        this.crmDataByZipTerritoryService.getPostCodeDetails(this.countriesBox.value,this.postCodeValue).subscribe({
          next: postCodeData => {
            
            if(postCodeData.length == 0){
              this.showCloserPostalCodes(this.countriesBox.value,this.postCodeValue.slice(0,3));
            }else{              
              this.postCodeId = postCodeData[0].postCodeId;
              this.postCodeDetailsGetDone = true;
              this.prepareRequest();
            }       
                       
          },
          error: (error: any) => {
            this.notificationService.alert("error", "Error while fetching Postal Code Data", error);
            this.postCodeDetailsGetDone = true;        
          }
        });
      }else{
        this.prepareRequest();
      }    
    }
  }

  prepareRequest(){
    
    this.crmReportRequest = new CRMReportRequest();

    this.crmReportRequest.requestedReports = this.reportList.selectedItems;

    if(this.isAllSegmentsSelected){
      this.crmReportRequest.majorSegments = [];
    }else{
      this.crmReportRequest.majorSegments = this.segmentDropDown.value;
    }
    

    this.crmReportRequest.gasPlant = this.gasPlantSelected;

    if(this.enableContractExpMonths){
      this.crmReportRequest.contractExpiresMonths = this.contractExpMonthsValue;
    }

    if(this.enableCompetitorSuppSelect){
      this.crmReportRequest.competitorOrSupp = this.competitorSuppValue;
    }

    if(this.searchBy == 'Territory'){
      this.crmReportRequest.salesSubRegionId = this.salesSubRegionBox.value;
      this.crmReportRequest.salesSubRegionValue = this.salesSubRegionBox.displayValue;
      this.crmReportRequest.doAllSalesRegionAcctsOnly = this.doAllSalesRegionAcctsOnly;
      this.crmReportRequest.territoryId = this.territorySelectBox.value;
      this.crmReportRequest.territoryValue = this.territorySelectBox.displayValue;
    }else{
      this.crmReportRequest.radiusCountryCode = this.countriesBox.value;
      this.crmReportRequest.postCodeId = this.postCodeId;
      this.crmReportRequest.postCodeValue = this.postCodeValue;
      this.crmReportRequest.radiusMiles = this.radiusMilesValue;
    }

    //console.log(this.crmReportRequest);

    this.rerender();

    this.filtersAccordion.instance.collapseItem(0);    
  }


  isReportSelected(searchReportName: string){
    return (this.crmReportRequest.requestedReports && this.crmReportRequest.requestedReports.findIndex(reportName => reportName == searchReportName) != -1);
  }

  isOnlySuspectsReportSelected(){
    return (this.reportList &&
      this.reportList.selectedItems.length == 1 &&
      this.reportList.selectedItems[0] == 'Suspects from D&B, all Segments');
  }

  rerender() {
    this.showTabPanel = false;

    //Set the first selected report's index as the selected tab index.
    this.selectedTabIndex = this.reports_all.findIndex(reportName => reportName == this.crmReportRequest.requestedReports[0]);
    
    this.changeDetectorRef.detectChanges();
    this.showTabPanel = true;
  }

}

